import { forEach } from 'lodash';
import { atom, atomFamily, CallbackInterface, selector } from 'recoil';
import { loadPersistedValue, persistOnSet } from '../effects';
import { configState } from './config';

export const aggregateUpdateCountState = atomFamily<number, { project: string; aggregateType: string }>({
  key: 'aggregate.updateCount',
  default: 0,
});

export const aggregateUpdateCountIncrementCallback =
  ({ set }: CallbackInterface) =>
  async (projects: string[], aggregateTypes: string[]) => {
    forEach(projects, project => {
      forEach(aggregateTypes, aggregateType => {
        set(aggregateUpdateCountState({ project, aggregateType }), prev => ++prev);
      });
    });
  };

export const visibleRecordTypeKeysState = atom<string[]>({
  key: 'visibleRecordTypeKeysState',
  default: selector({
    key: 'visibleRecordTypeKeysState.default',
    get: ({ get }) => get(configState).aggregateDefinitions.map(a => a.queryKey),
  }),
  effects: [loadPersistedValue, persistOnSet],
});
